/**
 * Gutenberg Block JS
 *
 * Import JS for Gutenberg blocks.
 */

// Custom Gutenberg Blocks.
// import './wd';
import './custom/faq';
